/**
 * Titres des pages redessinées avec la charte « apple » d'Open Design
 * (/Applications/Open Design.app/…/design-systems/apple/DESIGN.md) : titres
 * serrés, gras, dans la police du site (Plus Jakarta Sans, Karim 2026-10-18 :
 * on garde notre police, notre header et notre footer).
 *
 * Le site force TOUS les h1-h6 en MD Nichrome Dark avec `!important` dans
 * `@layer base` (main.css) : pour les règles !important l'ordre des couches
 * est inversé, aucune classe ne peut gagner. Seul un style en ligne
 * !important passe — d'où ces chaînes à poser en `:style`.
 * La police n'est chargée que jusqu'à 700 (nuxt.config `fonts`).
 */
const titre = (interligne: number, espacement: string) =>
  `font-family: var(--font-body) !important; font-weight: 700 !important; line-height: ${interligne} !important; letter-spacing: ${espacement} !important`;

/** Grand titre de page ou de chapitre (48-80 px). */
export const TITRE_APPLE = titre(1.05, "-0.035em");

/** Titre de section (32-48 px). */
export const TITRE_SECTION_APPLE = titre(1.08, "-0.03em");

/** Titre de carte (19-28 px). */
export const TITRE_CARTE_APPLE = titre(1.15, "-0.02em");
